"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRequiredConstraint = void 0;
const isRequiredConstraint = (constraint) => {
    return constraint.name === 'required';
};
exports.isRequiredConstraint = isRequiredConstraint;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWlyZWQuY29uc3RyYWludC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zdHJhaW50cy9yZXF1aXJlZC5jb25zdHJhaW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQU9PLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxVQUEwQixFQUFvQyxFQUFFO0lBQ25HLE9BQU8sVUFBVSxDQUFDLElBQUksS0FBSyxVQUFVLENBQUE7QUFDdkMsQ0FBQyxDQUFBO0FBRlksUUFBQSxvQkFBb0Isd0JBRWhDIn0=